import { __read, __awaiter, __generator } from 'tslib';
import * as React from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import { isRnaAnalysisTestSelection, flattenTestSelectionsToGeneConceptCodes, flattenTestSelectionsToTestCodes, removeConceptsFromTestSelections } from './OrderCard.utils.esm.js';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import { ExomeMetaTypeEnum } from '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import partition from 'lodash/partition';
import { helperMessageByCode } from '../../constants/helperMessages.esm.js';
import ExomeAddOnContainer from './ExomeAddOnContainer/ExomeAddOnContainer.esm.js';
import Header from './Header.esm.js';
import ReflexContainer from './ReflexContainer/ReflexContainer.esm.js';
import RereqContainer from './RereqContainer/RereqContainer.esm.js';
import RnaAnalysisContainer from './RnaAnalysisContainer/RnaAnalysisContainer.esm.js';
import SaveCustomPanelButton from './SaveCustomPanelButton.esm.js';
import CompactTestSelection from './TestSelection/CompactTestSelection.esm.js';
import TestSelection from './TestSelection/TestSelection.esm.js';
import styles from './OrderCard.module.esm.js';

var OrderCard = function (_a) {
    var _b;
    var clearOrderFromSession = _a.clearOrderFromSession, isRerequisition = _a.isRerequisition, orderGroup = _a.orderGroup, orderGroupIndex = _a.orderGroupIndex, orderGroupsCount = _a.orderGroupsCount;
    var _c = React.useContext(CartContext), _d = _c.featureFlags, _e = _d === void 0 ? {} : _d, _f = _e.cx_custom_rna_hcx, isCxCustomRnaHcxEnabled = _f === void 0 ? false : _f, meta = _c.meta, removeFromCart = _c.removeFromCart;
    var isCompact = React.useContext(CartSettingsContext).isCompact;
    var _g = orderGroup.meta, isReflexAvailable = _g.reflex.isReflexAvailable, _h = _g.rna, _j = _h === void 0 ? {} : _h, isParentRnaAnalysisAvailable = _j.isParentRnaAnalysisAvailable, isParentRnaAnalysisSelected = _j.isParentRnaAnalysisSelected, productType = orderGroup.productType, rereqSetCode = orderGroup.rereqSetCode, orderGroupTestSelections = orderGroup.testSelections;
    var _k = __read(partition(orderGroupTestSelections, function (testSelection) { return !isRnaAnalysisTestSelection(testSelection.name); }), 2), testSelections = _k[0], rnaAnalysisTestSelections = _k[1];
    var exome = (meta || {}).exome;
    var _l = exome || {}, exomeAddOnTargets = _l.addOnTargets, _m = _l.type, exomeType = _m === void 0 ? ExomeMetaTypeEnum.ProbandOnly : _m;
    var _o = __read(React.useState(false), 2), multiTestSaved = _o[0], setMultiTestSaved = _o[1];
    var conceptsFromTests = React.useCallback(function (_a) {
        var onlyGeneConcepts = _a.onlyGeneConcepts;
        return onlyGeneConcepts
            ? flattenTestSelectionsToGeneConceptCodes(testSelections)
            : flattenTestSelectionsToTestCodes(testSelections);
    }, [testSelections]);
    var handleDeleteOrderGroup = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(clearOrderFromSession && isRerequisition)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    // we want to clear session before removing test selection from cart-service because cart-service reads cart
                    // data from session. Also, we want to wait clearing in order to avoid race condition
                    return [4 /*yield*/, clearOrderFromSession()
                        // eslint-disable-next-line no-empty
                    ];
                case 2:
                    // we want to clear session before removing test selection from cart-service because cart-service reads cart
                    // data from session. Also, we want to wait clearing in order to avoid race condition
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    removeFromCart(removeConceptsFromTestSelections(testSelections), rereqSetCode);
                    return [2 /*return*/];
            }
        });
    }); }, [clearOrderFromSession, isRerequisition, removeFromCart, rereqSetCode, testSelections]);
    var handleDeleteTest = React.useCallback(function (_a) {
        var code = _a.code, genes = _a.genes;
        removeFromCart(code ? [code] : genes.map(function (_a) {
            var code = _a.code;
            return code;
        }));
        setMultiTestSaved(false);
    }, [removeFromCart]);
    var handleMultiTestSave = function () { return setMultiTestSaved(true); };
    var canSaveCustomPanel = !isCompact && testSelections.length > 1 && !multiTestSaved;
    var helperText = ((meta === null || meta === void 0 ? void 0 : meta.helperMessageCode) && helperMessageByCode.get(meta === null || meta === void 0 ? void 0 : meta.helperMessageCode)) || (meta === null || meta === void 0 ? void 0 : meta.helperMessageText);
    return (React.createElement("div", { className: isCompact ? styles.rootCompact : styles.root, "data-testid": "order-card" },
        React.createElement(Header, { handleDeleteOrderGroup: handleDeleteOrderGroup, orderGroup: orderGroup, orderGroupIndex: orderGroupIndex, orderGroupsCount: orderGroupsCount }),
        React.createElement("div", { className: styles.cardContentWrapper },
            isCompact ? (React.createElement(CompactTestSelection, { handleDeleteTest: handleDeleteTest, productType: orderGroup.productType, testSelections: testSelections })) : (React.createElement(TestSelection, { handleDeleteTest: handleDeleteTest, helperText: helperText, productType: orderGroup.productType, testSelections: testSelections })),
            isCxCustomRnaHcxEnabled && isParentRnaAnalysisAvailable && (React.createElement(RnaAnalysisContainer, { isReflex: false, isRnaAnalysisSelected: isParentRnaAnalysisSelected, rereqSetCode: rereqSetCode, rnaAnalysisTestSelection: rnaAnalysisTestSelections[0] })),
            isReflexAvailable && React.createElement(ReflexContainer, { orderGroup: orderGroup }),
            ((_b = meta === null || meta === void 0 ? void 0 : meta.rereq) === null || _b === void 0 ? void 0 : _b.isRerequisition) && React.createElement(RereqContainer, null),
            exomeAddOnTargets && React.createElement(ExomeAddOnContainer, { addOnTargets: exomeAddOnTargets, type: exomeType }),
            canSaveCustomPanel && (React.createElement(SaveCustomPanelButton, { concepts: conceptsFromTests({ onlyGeneConcepts: true }), handleMultiTestSave: handleMultiTestSave, isMultiTest: true, labelText: "Save all tests as a custom order", productType: productType })))));
};

export { OrderCard as default };
//# sourceMappingURL=OrderCard.esm.js.map
